import { paramCase } from 'change-case'
import { kuiperClassNames } from '@opallabs/kuiper'
import { doNothing } from '../../helpers/functions/doNothing'
import { GetContentByIDV2Return } from '../../helpers/types'
import { Stream } from './Stream'
import { styles } from './styles'

interface Props {
  display: string
  getContentByIdV2: (id: number) => Promise<GetContentByIDV2Return>
  isPresenting: boolean
  readOnly: boolean
  refreshedAt: string
  snapshotUrl: string
  tweetUrl: string
  updateText?: (val: string, destination: string) => void
}

export const LiveTweet: React.FC<Props> = ({
  display,
  getContentByIdV2,
  tweetUrl,
  isPresenting,
  readOnly,
  refreshedAt,
  snapshotUrl,
  updateText,
}) => (
  <div
    css={styles.baseStyles(display)}
    className={kuiperClassNames(
      'twitter live-tweet',
      `twitter-${paramCase(display)}`
    )}
  >
    <Stream
      display={display}
      isPresenting={isPresenting}
      getContentByIdV2={getContentByIdV2}
      onTweetUrlChange={
        updateText
          ? (val: string): void => updateText(val, 'tweet_url')
          : doNothing
      }
      onSnapshotUrlChange={
        updateText
          ? (val: string): void => updateText(val, 'snapshot_url')
          : doNothing
      }
      onRefreshedAtChange={
        updateText
          ? (val: string): void => updateText(val, 'refreshed_at')
          : doNothing
      }
      readOnly={readOnly}
      tweetUrl={tweetUrl}
      refreshedAt={refreshedAt}
      snapshotUrl={snapshotUrl}
    />
  </div>
)
